<template>
  <div class="filter-group">
    <h5>{{ title }}</h5>
    <el-switch
      style="display: block"
      v-model="isEnable"
      @change="changeFilter"
      active-color="#13ce66"
      inactive-color="#ff4949"
      active-text="Habilitar"
      inactive-text="Deshabilitar">
    </el-switch>

    <div v-if="isEnable" class="filter-group">

      <el-form-item label="Tipo de filtro">
        <el-radio-group
          size="mini"
          v-model="filterType"
          @change="changeType"
        >
          <el-radio-button label="include">Permitir</el-radio-button>
          <el-radio-button label="exclude">Bloquear</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="subtitle">
        <el-select
          v-model="selectedItems"
          multiple
          collapse-tags
          filterable
          @change="changeSelect"
          placeholder="Select">
        <el-option
          v-for="item in itemList"
          :key="item[1]"
          :label="item[0]"
          :value="item[1]">
        </el-option>
      </el-select>
      </el-form-item>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FilterCustom',
  props: [
    'title', 'subtitle', 'initialState', 'initialSelectedItems', 'initialFilterType', 'itemList',
  ],
  data() {
    return {
      isEnable: false,
      filterType: 'include',
      selectedItems: [],
    };
  },
  created() {
    this.isEnable = this.initialState;
    this.selectedItems = this.initialSelectedItems;
    this.filterType = this.initialFilterType;
  },
  watch: {
    initialState(newValue) {
      this.isEnable = newValue;
    },
    initialSelectedItems(newValue) {
      this.selectedItems = newValue;
    },
    initialFilterType(newValue) {
      this.filterType = newValue;
    },
  },
  methods: {
    changeFilter() {
      this.$emit('changeState');
    },
    changeSelect(value) {
      this.$emit('changeSelect', value);
    },
    changeType(value) {
      this.$emit('changeType', value);
    },
  },
};
</script>
